var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status=Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 3C44.9115 3 57 15.0883 57 30C57 44.9115 44.9115 57 30 57C15.0883 57 3 44.9115 3 30C3 15.0883 15.0883 3 30 3Z",
    fill: "#F84B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M30 1C46.0162 1 59 13.9838 59 30C59 46.0162 46.0162 59 30 59C13.9838 59 1 46.0162 1 30C1 13.9838 13.9838 1 30 1Z",
    stroke: "#F84B7A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.0008 36.1177C28.7498 36.1177 27.7508 35.1256 27.7508 33.9206V17.6471C27.7508 16.4421 28.7498 15.45 30.0008 15.45C31.252 15.45 32.2509 16.442 32.2509 17.6471V33.9206C32.2509 35.1257 31.252 36.1177 30.0008 36.1177Z",
    fill: "white",
    stroke: "#F84B7A",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30 44.5499C28.5832 44.5499 27.45 43.4264 27.45 42.0589C27.45 40.6916 28.5832 39.5679 30 39.5679C31.4168 39.5679 32.55 40.6916 32.55 42.0589C32.55 43.4264 31.4168 44.5499 30 44.5499Z",
    fill: "white",
    stroke: "#F84B7A",
    strokeWidth: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInformation);
export default __webpack_public_path__ + "static/media/error-information.401f261126eb5a1be2b25e8965914132.svg";
export { ForwardRef as ReactComponent };